import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router";
import {AwsRum} from "aws-rum-web";
import {App} from "./components/App";
import {RootRouter} from "./components/RootRouter";

// try {
// 	new AwsRum(
// 		"9853163e-4562-41ef-a9e8-91e955d8090e",
// 		"1.0.0",
// 		"eu-central-1",
// 		{
// 			sessionSampleRate: 1,
// 			identityPoolId: "eu-central-1:b42c20c7-a5c1-40ae-ab77-eae8b7e1030e",
// 			endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
// 			telemetries: ["performance", "errors", "http"],
// 			allowCookies: true,
// 			enableXRay: false,
// 		},
// 	);
// } catch (error) {
// 	console.error(error);
// }

const container = document.getElementById("root");

if (container) {
	createRoot(container).render(
		<BrowserRouter>
			<App>
				<RootRouter />
			</App>
		</BrowserRouter>,
	);
}
